import * as React from 'react';
import { useSelector } from 'react-redux';

import { OrderStatus } from '@websky/graphql';
import { getOrderStatus } from '../../../store/order/selectors';

interface Props {
	statuses: OrderStatus[];
	not?: boolean;
}

const OrderStatusGuard: React.FC<Props> = ({ statuses, not, children }) => {
	const status = useSelector(getOrderStatus);
	const isIncludeStatus = statuses.includes(status);

	if (not ? isIncludeStatus : !isIncludeStatus) {
		return null;
	}

	return <>{children}</>;
};

export default OrderStatusGuard;
